var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4988_120652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.24837 7L6.75163 7C7.25473 7 7.53443 7.58196 7.22015 7.97482L4.46852 11.4143C4.22833 11.7146 3.77167 11.7146 3.53148 11.4143L0.779853 7.97482C0.465567 7.58196 0.745271 7 1.24837 7Z",
    fill: "#9CADC3",
    stroke: "#9CADC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75163 5H1.24837C0.745271 5 0.465567 4.41804 0.779854 4.02518L3.53148 0.585652C3.77167 0.285408 4.22833 0.285408 4.46852 0.585652L7.22015 4.02518C7.53443 4.41804 7.25473 5 6.75163 5Z",
    fill: "#9CADC3",
    stroke: "#9CADC3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4988_120652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.7c20b20a7fefc6a5555e98452056ba2d.svg";
export { ForwardRef as ReactComponent };